module.exports = __webpack_public_path__ + "static/media/ic_video.2403725f.svg";